/* @flow */
import cx from 'classnames';
import Group from 'entities/Group';
import GroupItem from './GroupOrgList-GroupItem.jsx';
import Organization from 'entities/Organization';
import OrganizationItem from './GroupOrgList-OrganizationItem.jsx';
import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import './styles/GroupOrgList.scss';

type Listable = Group | Organization;

/**
 * Displays a list of mixed organizations and groups in the GroupNav
 */
class GroupOrgList extends React.Component {
  static propTypes = {
    items: React.PropTypes.arrayOf(
      React.PropTypes.oneOfType([
        React.PropTypes.instanceOf(Group),
        React.PropTypes.instanceOf(Organization),
      ])
    ).isRequired,
  };

  // typecheck: ignore statement
  shouldComponentUpdate(nextProps: {items: Listable[]}) {
    return shallowCompare(this, nextProps);
  }

  // typecheck: ignore statement
  renderItem = (item: Listable) => {
    if (item instanceof Organization) {
      return <OrganizationItem organization={item} key={`org-${item.id}`} />;
    } else if (item instanceof Group) {
      return (
        <GroupItem
          group={item}
          key={`group-${item.id}`}
        />
      );
    } else {
      console.error('Unsupported list item', item);
      return null;
    }
  };

  render() {
    const { items, className } = this.props;

    return (
      <ul
        className={cx('GroupOrgList', className)}>
        {items.map(this.renderItem)}
      </ul>
    );
  }
}

export default GroupOrgList;



// WEBPACK FOOTER //
// ./src/groups/components/GroupOrgList.jsx